import { AxiosInstance } from "axios"
import { AccountingDimension } from "./accountNumbersTypes"
import { ImportResultData } from "../../../../../core/api/apiTypes"
import { ImportCsvFile } from "../../../../../shared/components/importCsv/importCsvFileTypes"
import { createImportCsvFormData } from "../../../../../shared/components/importCsv/helpers"

export enum CompanyAccountNumbersQuery {
    ACCOUNTING_DIMENSIONS_FOR_COMPANY = "accounting-dimensions-for-company",
}

type DimensionsParams = Readonly<{
    companyId: number
}>
export type DimensionsResponse = Readonly<{
    accountingDimensions: AccountingDimension[]
}>

export async function fetchDimensionsForCompany(
    { companyId }: DimensionsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DimensionsResponse> {
    const url = `/companies/${companyId}/accounting/dimensions`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

type ImportAccountNumbersParams = Readonly<{
    companyId: number
    dimensionId: number
    importData: ImportCsvFile
}>

export async function importAccountNumbers(
    { companyId, dimensionId, importData }: ImportAccountNumbersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ImportResultData> {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        signal,
    }

    const { data } = await axios.post(
        `/companies/${companyId}/accounting/dimensions/${dimensionId}/import`,
        createImportCsvFormData(importData),
        config,
    )

    return data
}
